import { computed, ref } from "vue";
import { storageDefaults } from "#blokkli-build/config";
const PREFIX = "blokkli:";
const getExisting = (key) => {
  try {
    const value = localStorage.getItem(key);
    if (value) {
      return JSON.parse(value);
    }
  } catch {
  }
};
export default function() {
  const values = ref({});
  const defaults = ref({});
  const use = (key, providedDefaultValue) => {
    const storageKey = computed(
      () => PREFIX + (typeof key === "string" ? key : key.value)
    );
    const storageDefaultsValue = storageDefaults[typeof key === "string" ? key : key.value];
    const defaultValue = storageDefaultsValue && typeof storageDefaultsValue === typeof providedDefaultValue ? storageDefaultsValue : providedDefaultValue;
    if (!defaults.value[storageKey.value]) {
      defaults.value[storageKey.value] = defaultValue;
    }
    if (values.value[storageKey.value] === void 0) {
      const existing = getExisting(storageKey.value);
      if (existing !== void 0) {
        values.value[storageKey.value] = existing;
      } else {
        values.value[storageKey.value] = defaultValue;
      }
    }
    return computed({
      get() {
        const v = values.value[storageKey.value];
        if (v === void 0) {
          return defaults.value[storageKey.value];
        }
        return v;
      },
      set(newValue) {
        values.value[storageKey.value] = newValue;
        window.localStorage.setItem(storageKey.value, JSON.stringify(newValue));
      }
    });
  };
  const clearAll = () => {
    values.value = {};
    Object.keys(window.localStorage).forEach((key) => {
      if (key.startsWith(PREFIX)) {
        window.localStorage.removeItem(key);
      }
    });
  };
  const clear = (key) => {
    const storageKey = PREFIX + key;
    values.value[storageKey] = void 0;
    window.localStorage.removeItem(storageKey);
  };
  return { use, clearAll, clear };
}
